import { useState, useCallback, useEffect } from "react";
import { useLoggedUser } from "state/reactive-vars/logged-user-var";
import { Properties, Maybe } from "graphql/generated/graphql";

interface UsePropertyDocumentsModalReturn {
  // State
  propertyDocumentsModalOpen: boolean;
  selectedProperty: Maybe<Properties> | undefined;
  
  // Actions
  openPropertyDocumentsModal: () => void;
  closePropertyDocumentsModal: () => void;
  setPropertyDocumentsModalOpen: (open: boolean) => void;
  openModalWithProperty: (property: Maybe<Properties> | undefined) => void;
  handleOnSelectProperty: (args: { key: string }) => void;
  
  // Data
  userProperties: any[];
  hasProperties: boolean;
}

export const usePropertyDocumentsModal = (): UsePropertyDocumentsModalReturn => {
  const { loggedUserValue } = useLoggedUser();
  
  // Initialize default property
  const defaultProperty = 
    loggedUserValue && loggedUserValue.user_properties
      ? loggedUserValue?.user_properties[0]?.property
      : undefined;
  
  // State
  const [propertyDocumentsModalOpen, setPropertyDocumentsModalOpen] = useState<boolean>(false);
  const [selectedProperty, setSelectedProperty] = useState<Maybe<Properties> | undefined>(defaultProperty);
  
  // Update selected property when user properties change
  useEffect(() => {
    if (!selectedProperty && loggedUserValue && loggedUserValue.user_properties) {
      const newDefaultProperty = loggedUserValue.user_properties[0]?.property;
      setSelectedProperty(newDefaultProperty);
    }
  }, [loggedUserValue.user_properties, selectedProperty]);
  
  // Actions
  const openPropertyDocumentsModal = useCallback(() => {
    setPropertyDocumentsModalOpen(true);
  }, []);
  
  const closePropertyDocumentsModal = useCallback(() => {
    setPropertyDocumentsModalOpen(false);
  }, []);
  
  const openModalWithProperty = useCallback((property: Maybe<Properties> | undefined) => {
    setSelectedProperty(property);
    console.log('property :>> ', property);
    setPropertyDocumentsModalOpen(true);
  }, []);
  
  const handleOnSelectProperty = useCallback(
    (args: { key: string }) => {
      const { key } = args;

      if (loggedUserValue && loggedUserValue.user_properties) {
        const selectedUserProperty = loggedUserValue.user_properties.find(
          (element) => element.property?.id === key
        );

        if (selectedUserProperty && selectedUserProperty.property) {
          setSelectedProperty(selectedUserProperty.property);
        }
      }
    },
    [loggedUserValue.user_properties]
  );
  
  // Computed values
  const userProperties = loggedUserValue?.user_properties || [];
  const hasProperties = userProperties.length > 0;
  
  return {
    // State
    propertyDocumentsModalOpen,
    selectedProperty,
    
    // Actions
    openPropertyDocumentsModal,
    closePropertyDocumentsModal,
    setPropertyDocumentsModalOpen,
    openModalWithProperty,
    handleOnSelectProperty,
    
    // Data
    userProperties,
    hasProperties,
  };
};

export default usePropertyDocumentsModal;
